import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import useJellyIndicator from "./useJellyIndicator";
import "./IconBar.css";

export default function JellyTabsList({ value, items, label }) {
  const { trackRef, itemRefs, phase, variables, indicatorStyle } = useJellyIndicator(value);

  return (
    <TabsList ref={trackRef} aria-label={label} className="icon-bar jelly-tabs h-auto" style={variables}>
      <span className="icon-bar__indicator" data-phase={phase} style={indicatorStyle} aria-hidden="true" />
      {items.map((item) => (
        <TabsTrigger
          key={item.value}
          value={item.value}
          ref={(element) => { itemRefs.current[item.value] = element; }}
          data-testid={item.testid}
          className="jelly-tabs__trigger relative z-10 h-7 rounded-[9px] text-slate-400 data-[state=active]:bg-transparent data-[state=active]:text-[#071A33] data-[state=active]:shadow-none focus-visible:ring-offset-0"
        >
          {item.label}
        </TabsTrigger>
      ))}
    </TabsList>
  );
}
